<script lang="ts">
  import Arrow from "./Arrow.svelte";
  interface Props {
    hide?: boolean;
    disabled?: boolean;
    onClick: () => void;
  }

  let { hide = false, disabled = false, onClick }: Props = $props();
</script>

<button
  {disabled}
  id="back-button"
  onclick={onClick}
  class="flex group items-center mr-4 {hide ? 'invisible' : ''}"
>
  <Arrow
    class="transform transition rotate-180 mr-2 scale-90 sm:scale-100 group-hover:-translate-x-0.5"
  />
  <span class="text-Violet700 text-S font-bold">Bakåt</span>
</button>
